import fields from '@/lib/fields'
const KItemMedia = () => import( /* webpackChunkName: "model-blocks" */ '@/blocks/k-item-media.vue' )
const AdminEditMediaPage = () => import( /* webpackChunkName: "model-pages" */ '@/pages/admin/edit/Media.vue')
const AdminEditProgramPage = () => import( /* webpackChunkName: "model-pages" */ '@/pages/admin/edit/Program.vue')

export const models = {
  attachment_category: {
    name: 'attachment_category',
    label: 'Content Category',
    plural: 'Content Categories',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Attachment_category',
    path: 'att-category',
    components: {
      objects: '',
      item: '',
    }
  },
  attachment_tag: {
    name: 'attachment_tag',
    label: 'Content Tag',
    plural: 'Content Tags',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Attachment_tag',
    path: 'att-tag',
    components: {
      objects: '',
      item: '',
    }
  },
  category: {
    name: 'category',
    label: 'Category',
    plural: 'Categories',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Category',
    path: 'category',
    components: {
      objects: '',
      item: '',
    }
  },
  collection: {
    name: 'collection',
    label: 'Collection',
    plural: 'Collections',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Collection',
    path: 'collection',
    components: {
      objects: '',
      item: '',
    }
  },
  comment: {
    name: 'comment',
    label: 'Comment',
    plural: 'Comments',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Comment',
    path: 'comment',
    components: {
      objects: '',
      item: '',
    }
  },
  media: {
    name: 'media',
    label: 'Media',
    plural: 'Media',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Media',
    path: 'media',
    components: {
      // objects: 'k-objects-media',
      item: () => KItemMedia,
      edit: () => AdminEditMediaPage,
    },
    fields: {
      alt_text: {
        field: fields.string,
      },
      attachment_category: {
        field: fields.att_categories,
        // multiple: true
      },
      attachment_tag: {
        field: fields.att_tags,
        // multiple: true
      },
      collection: {
        field: fields.collections,
        // multiple: true
      },
      caption: {
        field: fields.summary,
        rendered: true,
      },
      description: {
        field: fields.text,
        rendered: true,
      },
      post: {
        field: fields.post,
      },
      restrictions: {
        field: fields.content_restrictions,
      },
      show_text: {
        field: fields.bool,
      },
      slug: {
        field: fields.slug,
      },
      title: {
        field: fields.title,
        rendered: true,
      }
    }
  },
  membership: {
    name: 'membership',
    label: 'Membership',
    plural: 'Memberships',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Membership',
    path: 'membership',
    components: {
      objects: '',
      item: '',
    }
  },
  page: {
    name: 'page',
    label: 'Page',
    plural: 'Pages',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Page',
    collection: 'Pages',
    path: 'page',
    components: {
      objects: '',
      item: '',
      edit: '',
    }
  },
  pagerevision: {
    name: 'pagerevision',
    label: 'Page Revision',
    plural: 'Page Revisions',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'PageRevision',
    path: 'page-revision',
    components: {
      objects: '',
      item: '',
    }
  },
  pagesautosaves: {
    name: 'pagesautosaves',
    label: 'Page Autosaves',
    plural: 'Page Autosaves',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'PageAutosaves',
    path: 'pagesautosaves',
    components: {
      objects: '',
      item: '',
    }
  },
  path: {
    name: 'path',
    label: 'Path',
    plural: 'Paths',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Path',
    path: 'path',
    components: {
      objects: '',
      item: '',
    }
  },
  post: {
    name: 'post',
    label: 'Post',
    plural: 'Posts',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Post',
    collection: 'Posts',
    path: 'post',
    components: {
      objects: '',
      item: '',
    }
  },
  postrevision: {
    name: 'postrevision',
    label: 'Post Revision',
    plural: 'Post Revisions',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'PostRevision',
    path: 'postrevision',
    components: {
      objects: '',
      item: '',
    }
  },
  postsautosaves: {
    name: 'postsautosaves',
    label: 'Post Autosaves',
    plural: 'Post Autosaves',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'PostAutosaves',
    path: 'postsautosaves',
    components: {
      objects: '',
      item: '',
    }
  },
  preview: {
    name: 'preview',
    label: 'Preview',
    plural: 'Previews',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Preview',
    path: 'preview',
    components: {
      objects: '',
      item: '',
    }
  },
  product: {
    name: 'product',
    label: 'Product',
    plural: 'Products',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Product',
    path: 'product',
    components: {
      objects: '',
      item: '',
    }
  },
  productautosaves: {
    name: 'productautosaves',
    label: 'Product Autosaves',
    plural: 'Product Autosaves',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'ProductAutosaves',
    path: 'productautosaves',
    components: {
      objects: '',
      item: '',
    }
  },
  program: {
    name: 'program',
    label: 'Program',
    plural: 'Programs',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Page',
    collection: 'Pages',
    path: 'page',
    filter: {
      meta_key: 'program',
      meta_value: 1
    },
    components: {
      // objects: ( post ) => post.type === 'program' ? AdminEditProgramPage : null,
      item: '',
      edit: () => AdminEditProgramPage,
    }
  },
  release: {
    name: 'release',
    label: 'Release',
    plural: 'Releases',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'release',
    components: {
      objects: '',
      item: '',
    }
  },
  releaseautosaves: {
    name: 'releaseautosaves',
    label: 'Release Autosaves',
    plural: 'Release Autosaves',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'releaseautosaves',
    components: {
      objects: '',
      item: '',
    }
  },
  releaserevisions: {
    name: 'releaserevisions',
    label: 'Release Revisions',
    plural: 'Release Revisions',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'releaserevisions',
    components: {
      objects: '',
      item: '',
    }
  },
  schema: {
    name: 'schema',
    label: 'Schema',
    plural: 'Schemas',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'schema',
    components: {
      objects: '',
      item: '',
    }
  },
  settings: {
    name: 'settings',
    label: 'Settings',
    plural: 'Settings',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'settings',
    components: {
      objects: '',
      item: '',
    }
  },
  status: {
    name: 'status',
    label: 'Status',
    plural: 'Statuses',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'status',
    components: {
      objects: '',
      item: '',
    }
  },
  tag: {
    name: 'tag',
    label: 'Tag',
    plural: 'Tags',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    model: 'Tag',
    collection: 'Tags',
    path: 'tag',
    components: {
      objects: '',
      item: '',
    }
  },
  taxonomy: {
    name: 'taxonomy',
    label: 'Taxonomy',
    plural: 'Taxonomies',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'taxonomy',
    components: {
      objects: '',
      item: '',
    }
  },
  type: {
    name: 'type',
    label: 'Type',
    plural: 'Types',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'type',
    components: {
      objects: '',
      item: '',
    }
  },
  user: {
    name: 'user',
    label: 'User',
    plural: 'Users',
    icons: {
      add: '',
      edit: '',
      rm: '',
    },
    path: 'user',
    components: {
      objects: '',
      item: '',
    }
  },
}

export default {
  fields,
  models
}
